import * as React from 'react';
import DatetimePicker from 'components/form/date-time-picker';
import { LabelButton, Drawer, Table, Input } from '@teamsnap/snap-ui';
import AddOrderLineItemDrawer from './AddOrderLineItemDrawer';

interface Props {
  orgId: string;
  dueDate: Date;
  setDueDate: (any) => void;
  orderLineItems: any[];
  setOrderLineItems: (any) => void;
  userIds: any[];
  setUserIds: (any) => void;
}

const SendInvoice = ({ orgId, dueDate, setDueDate, orderLineItems, setOrderLineItems, userIds, setUserIds }: Props) => {
  const [showDrawer, setShowDrawer] = React.useState(false);

  return (
    <>
      <h3>Due date</h3>
      <p className="sui-mb-1">* Invoice must be paid in full, or a payment plan must be set up.</p>
      <DatetimePicker
        id="invoice-due-date"
        datetime={dueDate ? new Date(dueDate) : null}
        onChange={(date) => setDueDate(date)}
        showTimeSelect={false}
        dateFormat="P"
        startDate={new Date()}
        placeholderText="MM/ DD / YYYY"
      />
      <br />

      <h3 className="sui-mt-3">Invoice line items</h3>
      <p className="sui-mb-1">* Set line items for each user invoice.</p>
      <br />
      <div className="sui-my-2">
        <LabelButton
          icon="add"
          iconPosition="left"
          labelText="Add invoice line item"
          onClick={() => {
            setShowDrawer(!showDrawer);
          }}
        />
      </div>

      <Drawer
        title={<h3>Add invoice line item</h3>}
        testId="AddOrderLineItemDrawer"
        open={showDrawer}
        size="large"
        allowOverlayClose={false}
        onCloseClick={() => setShowDrawer(false)}
        showOverlay={true}
        allowBodyScroll={false}
      >
        {showDrawer && (
          <AddOrderLineItemDrawer
            orderLineItems={orderLineItems}
            setOrderLineItems={(data) => setOrderLineItems(data)}
            onClose={() => setShowDrawer(false)}
          />
        )}
      </Drawer>

      <Table
        headerRow={{
          cells: [
            {
              text: 'Name',
              type: 'header',
            },
            {
              text: 'Description',
              type: 'header',
            },
            {
              text: 'Type',
              type: 'header',
            },
            {
              text: 'Amount',
              type: 'header',
            },
          ],
        }}
        placeholder="Start adding line items to the invoice! :)"
        rows={orderLineItems.map((item) => ({
          cells: [
            {
              text: item.name,
              type: 'text',
            },
            {
              text: item.description,
              type: 'text',
            },
            {
              text: item.type,
              type: 'text',
            },
            {
              text: parseFloat(item.amount).toFixed(2),
              type: 'text',
            },
          ],
        }))}
      />
      <br />

      <h3 className="sui-mt-3">User ids</h3>
      <p className="sui-mb-1">* Set users to be invoiced by entering user ids.</p>
      <Input
        value={userIds.join(',')}
        required={true}
        type="text"
        name="userIds"
        placeholder="e.g. 12345,151782"
        onChange={(event) => setUserIds(event.target.value.split(','))}
        className="sui-mb-4 sui-mt-2"
      />
      <br />
      <br />
    </>
  );
};

export default SendInvoice;
